import { Storage } from "../Storage/Storage";


const useDetails = Storage.get('auth')

export default function CheckAccess (id,permission) {
    if(useDetails?.admin_type && useDetails.admin_type==="SUPERADMIN"){
        return true
    }else{
        let data = useDetails?.access?.find((item)=> item?.item_id && id && String(item.item_id)===String(id))
        if(data){
            if(data.permissions.includes(permission)) return true
        }
    }
    return false
}
  